export const BLOCKING_POPUP_SET = 'BLOCKING_POPUP_SET';
export const blockingPopupSet = (isOpen, title, text) => ({ type: BLOCKING_POPUP_SET, title, isOpen, text });

const defaultState = {
    isOpen: false,
    text: '',
    title: '',
}

export const blockingPopupReducer = (state = defaultState, action) => {
    switch (action.type) {
        case BLOCKING_POPUP_SET: {
            return { ...state, isOpen: action.isOpen, text: action.text, title: action.title }
        }
        default: {
            return state;
        }
    }
}